import { render } from "./B2bTableMenuFacturas.vue?vue&type=template&id=51dd257f&scoped=true&lang=pug"
import script from "./B2bTableMenuFacturas.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuFacturas.vue?vue&type=script&lang=js"

import "./B2bTableMenuFacturas.vue?vue&type=style&index=0&id=51dd257f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51dd257f"]])

export default __exports__